export const setupGrid = () => {
    const filterInputs = document.querySelectorAll('.ag-floating-filter-input input');
    for (const obj of Array.from(filterInputs)) {
        if (obj.attributes.getNamedItem('disabled') != null) {
            // skip columns with disabled filter
            return;
        }
        obj.setAttribute('placeholder', 'Filter');
    }
};
